<script setup lang="ts">
import { NButton, NCard, NPagination } from 'naive-ui'
import { onMounted, ref } from 'vue'

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
  showSizePickerGrid: {
    type: Boolean,
    required: false,
    default: false,
  },
  itemCountPrefix: {
    type: Number,
    required: false,
    default: 0,
  },
  showItemCount: {
    type: Boolean,
    required: false,
    default: false,
  },
  cardContentStyle: {
    type: [Object, String],
    required: false,
    default: undefined,
  },
  showCard: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits<{
  (e: 'update:page', page: number): void
  (e: 'update:pageSize', pageSize: number): void
}>()

const pageSizes = ref<any[]>([])

const onUpdatePage = (page: number): void => {
  emit('update:page', page)
}
const onUpdatePageSize = (pageSize: number): void => {
  emit('update:pageSize', pageSize)
}

const getPageSizes = () => {
  if (props.pagination.pageSizes.length) {
    pageSizes.value = props.pagination.pageSizes.map((item) => {
      return { value: item, label: item }
    })
  }
}

onMounted(() => {
  getPageSizes()
})
</script>

<template>
  <component
    :is="showCard ? NCard : 'div'"
    :class="showCard ? '!rounded-lg shadow' : ''"
    :size="showCard ? 'small' : undefined"
    :content-style="showCard ? cardContentStyle : undefined"
  >
    <div class="flex justify-between items-center">
      <NPagination
        :page="pagination.page"
        :item-count="pagination.itemCount"
        :show-item-count="showItemCount"
        :prev="pagination.prev"
        :next="pagination.next"
        :page-size="pagination.pageSize"
        :page-sizes="pagination.pageSizes"
        :show-size-picker="pagination.showSizePicker"
        :show-quick-jumper="pagination.showQuickJumper"
        :show-quick-jump-dropdown="pagination.showQuickJumpDropdown"
        :page-slot="pagination.pageSlot"
        :on-update:page="onUpdatePage"
        :on-update:page-size="onUpdatePageSize"
      >
        <template #prefix="{ itemCount }">
          <div v-if="showItemCount">
            {{ itemCount }} {{ itemCountPrefix || $t('common.result') }}
          </div>
        </template>
      </NPagination>
      <div v-if="!pagination.showSizePicker && showSizePickerGrid" class="flex gap-2">
        <NButton v-for="(pageSize, index) in pagination.pageSizes" :key="index" size="small" class="page-size-chunk" :class="pageSize === pagination.pageSize ? 'active' : ''" @click="onUpdatePageSize(pageSize)">
          {{ pageSize }}
        </NButton>
      </div>
    </div>
  </component>
</template>

<style scoped>
:deep(.n-pagination) {
	display: flex;
	width: 100%;
}
:deep(.n-pagination .n-pagination-prefix) {
	margin-right: auto;
}

:deep(.n-button.page-size-chunk.active) {
	background: #0000;
	color: #764ab9;
}
:deep(.n-button.page-size-chunk.active .n-button__border) {
	border-color: #764ab9;
}
</style>
